
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business-model",
      function () {
        return require("private-next-pages/business-model.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/business-model"])
      });
    }
  